<template>
      <div class="list-table">
         <el-row class="list-table-row">
            <el-col :span="4" class="list-table-row-header">
                <span>课程</span>
            </el-col>
            <el-col :span="10" class="list-table-row-content">
                <span v-text="getCourseName(course1)"></span>
            </el-col>
             <el-col :span="10" class="list-table-row-content">
                <span v-text="getCourseName(course2)"></span>
            </el-col>
        </el-row>
        <el-row class="list-table-row cs-row-student">
            <el-col :span="4" class="list-table-row-header">
                <span>不同学生</span>
            </el-col>

             <el-col :span="10" class="list-table-row-content">
                <span v-if="diffStudentList2.length == 0">&nbsp;</span>
              <span :class="{'cs-list-item':true, 'isClicked':checkDiffStudent2IsClicked(index)}" v-for="(item,index) in diffStudentList2" :key="index" @click="showStudent(item.Id, 2, index)" v-text="formatPhone(item.Phone)"></span>
            </el-col>
            <el-col :span="10" class="list-table-row-content">
                <span v-if="diffStudentList1.length == 0">&nbsp;</span>
              <span :class="{'cs-list-item':true, 'isClicked':checkDiffStudent1IsClicked(index)}" v-for="(item,index) in diffStudentList1" :key="index" @click="showStudent(item.Id, 1, index)" v-text="formatPhone(item.Phone)"></span>
            </el-col>
        </el-row>
        <el-row class="list-table-row cs-row-student">
            <el-col :span="4" class="list-table-row-header">
                <span>相同学生</span>
            </el-col>
            <el-col :span="20" class="list-table-row-content">
              <span v-if="sameStudentList.length == 0">&nbsp;</span>
              <span :class="{'cs-list-item':true, 'isClicked':checkSameStudenIsClicked(index)}" v-for="(item,index) in sameStudentList" :key="index" @click="showStudent(item.Id, 3, index)" v-text="formatPhone(item.Phone)"></span>
            </el-col>
        </el-row>
    <el-dialog append-to-body title="在校课程时间表" :center="true" :close-on-click-modal="false" width="70%" :visible.sync="displayStudentCourse" top="5vh">
      <studentCourseReview :data="currentStudentData" @close="closeStudentCourse" v-on:dialogFormVisibleEvent="onDialogFormVisibleEvent"></studentCourseReview>
    </el-dialog> 
    </div>
</template>

<style lang="scss" scoped>
.list-table {
  width: 100%;
  padding: 0 40px;
  margin-bottom: 40px;

  .list-table-row {
    border-bottom: 1px solid #dbdbdb;
    border-left: 1px solid #dbdbdb;
    border-right: 1px solid #dbdbdb;
    line-height: 50px;

    &:first-child {
      border-top: 1px solid #dbdbdb;
      line-height: 33px;
      background-color: #f0f0f0;
    }

    .list-table-row-header {
      background-color: #f0f0f0;
      font-weight: bold;
      text-align: center;
      min-height: 50px;
    }
    .list-table-row-content {
      text-align: left;
      padding: 0 30px;
      display: flex;
      flex-wrap: wrap;
      min-height: 50px;

      .cs-list-item {
        text-align: left;
        width: 25%;
        //flex: 1;
        padding: 3px 5px;
        display: block;
        cursor: pointer;
        color: #3388c2;
        line-height: 25px;

        &:hover {
          opacity: 0.9;
        }
      }
    }

    &.cs-row-student {
      position: relative;

      .list-table-row-header {
        position: absolute;
        height: 100%;
      }

      .list-table-row-content {
        float: right;
      }
    }
  }
}
</style>

<script>
import studentCourseReview from "../studentCourseReview";
import { compareCourse } from "../../service/speedupCourse.service";
import { formatPhone } from "../../config/mUtils";

export default {
  data() {
    return {
      displayStudentCourse: false,
      currentStudentData: {},
      course1: {},
      course2: {},
      diffStudentList1: [],
      diffStudentList2: [],
      sameStudentList: [],
      planId: 0,
      termId: 0,
      clickedSameStudentList: [],
      clickedDiffStudentList1: [],
      clickedDiffStudentList2: []
    };
  },
  components: {
    studentCourseReview
  },
  props: {
    data: {}
  },
  created() {
    this.loadData();
  },
  methods: {
    formatPhone(phone){
      if (!this.USERMANAGER.isAdmin){
        return formatPhone(phone);
      }
      return phone;
    },
    closeStudentCourse() {
      this.displayStudentCourse = false;
    },
    onDialogFormVisibleEvent(visible) {
      this.displayStudentCourse = visible;
    },
    showStudent(id, type, index) {
      this.currentStudentData = {
        studentId: id,
        planId: this.planId,
        termId: this.termId
      };
      this.displayStudentCourse = true;

      let list = [];
      if (type == 1){    
        this.clickedDiffStudentList1.forEach(element => {
          list.push(element);
        });
        list[index] = true;
        this.clickedDiffStudentList1 = list;
      }else if (type == 2){
        this.clickedDiffStudentList2.forEach(element => {
          list.push(element);
        });
        list[index] = true;
        this.clickedDiffStudentList2 = list;
      }else if (type == 3){
        this.clickedSameStudentList.forEach(element => {
          list.push(element);
        });
        list[index] = true;
        this.clickedSameStudentList = list;
      }
  
    },
    compareSpeedupCourse() {
      let course1Data = {
        courseId: this.course1.CourseId,
        teacherId: this.course1.TeacherId,
        courseClass: this.course1.CourseClass
      };
      let course2Data = {
        courseId: this.course2.CourseId,
        teacherId: this.course2.TeacherId,
        courseClass: this.course2.CourseClass
      };
      compareCourse(this.termId, this.planId, course1Data, course2Data).then(result => {
        if (!!result && result.success) {
          this.diffStudentList1 = result.data.DiffStudentList1;
          this.diffStudentList2 = result.data.DiffStudentList2;
          this.sameStudentList = result.data.SameStudentList;

          this.clickedDiffStudentList1 = [];
          this.diffStudentList1.forEach(element => {
            this.clickedDiffStudentList1.push(false);
          });
          this.clickedDiffStudentList2 = [];
          this.diffStudentList2.forEach(element => {
            this.clickedDiffStudentList2.push(false);
          });
          this.clickedSameStudentList = [];
          this.sameStudentList.forEach(element => {
            this.clickedSameStudentList.push(false);
          });

        } else {
        }
      });
    },
    checkDiffStudent1IsClicked(index) {
      return this.clickedDiffStudentList1[index];
    },
    checkDiffStudent2IsClicked(index) {
      return this.clickedDiffStudentList2[index];
    },
    checkSameStudenIsClicked(index) {
      return this.clickedSameStudentList[index];
    },
    getCourseName(course) {
      if (!course) return "";
      let courseName = course.CourseName;
      if (course.CourseClass) {
        courseName += "-分班" + course.CourseClass;
      }
      return courseName;
    },
    loadData() {
      this.course1 = this.data.course1;
      this.course2 = this.data.course2;
      this.planId = this.data.planId;
      this.termId = this.data.termId;
      this.compareSpeedupCourse();
    }
  },
  watch: {
    data: function() {
      this.loadData();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/speedupCourse/speedupCourseCompare.vue